var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircularDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 32.00 32.00",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b595",
    d: " M 18.21 0.00 Q 28.93 2.06 32.00 12.53 L 32.00 19.17 Q 29.34 29.69 18.43 32.00 L 14.52 32.00 Q 2.87 29.95 0.49 19.00 Q -0.72 13.43 2.51 7.76 Q 6.19 1.31 14.45 0.00 L 18.21 0.00 Z M 16.27 22.01 Q 16.89 22.01 17.22 21.69 Q 20.00 19.04 23.79 15.02 Q 24.54 14.22 23.99 13.28 Q 23.91 13.13 23.78 13.02 Q 22.66 12.07 21.93 12.76 Q 19.35 15.24 16.65 18.04 Q 16.56 18.13 16.48 18.16 Q 16.40 18.18 16.26 18.18 Q 16.11 18.18 16.04 18.16 Q 15.96 18.13 15.87 18.04 Q 13.16 15.25 10.57 12.78 Q 9.83 12.09 8.72 13.05 Q 8.59 13.16 8.51 13.31 Q 7.96 14.25 8.71 15.05 Q 12.52 19.05 15.31 21.70 Q 15.64 22.01 16.27 22.01 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircularDownArrow);
export default __webpack_public_path__ + "static/media/greenCircularDownArrow.3c866afdc90b12e5d20ef14d9673d11a.svg";
export { ForwardRef as ReactComponent };